import { createTRPCClient, httpLink } from "@trpc/client"
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query"
import superjson from "superjson"

import { queryClient } from "@/services/tanstackQuery/queryClient"

import type { MainRouter } from "../../../backend/src/routers/trpc/trpcRouter"

export const trpc = createTRPCClient<MainRouter>({
  links: [
    httpLink({
      url: "/api/trpc",
      transformer: superjson,
      headers() {
        const sessionId = document.location.pathname.split("/")?.[1]
        return {
          "X-Session-Id": sessionId,
        }
      },
    }),
  ],
})

// Singleton proxy works outside React too (route loaders)
export const trpcOptions = createTRPCOptionsProxy<MainRouter>({ client: trpc, queryClient })
